import carImage from '../assets/car/car.webp'
import frontRim from '../assets/car/wheel-front-rim.webp'
import frontHub from '../assets/car/wheel-front-hub.webp'
import rearRim from '../assets/car/wheel-rear-rim.webp'
import rearHub from '../assets/car/wheel-rear-hub.webp'

export { carImage, frontRim, frontHub, rearRim, rearHub }

const load = (url) =>
  new Promise((resolve) => {
    const image = new Image()
    image.onload = resolve
    image.onerror = resolve
    image.src = url
  })

// Loads the car images before the scene starts, so the car does not pop in half way. Stops waiting after `timeoutMs`.
export function preloadCarAssets(timeoutMs = 4000) {
  const loaded = Promise.all([carImage, frontRim, frontHub, rearRim, rearHub].map(load))
  const timeout = new Promise((resolve) => setTimeout(resolve, timeoutMs))
  return Promise.race([loaded, timeout])
}
